const docVerifyResources = {
  en: {
    docVerify: {
      title: 'Document verification',
      loading: 'Loading document...',
      httpError: 'Request error',
      noData: 'No data available',
      badRequest: 'Request error',
      validationError: 'Validation error',
      documentNumber: 'Number',
      documentDate: 'Date',
      signType: 'Signature type',
      author: 'Author',
      sender: 'Sender',
      signers: 'Signers',
      decision: 'Decision',
      signedAt: 'Signed at',
    },
  },
  kz: {
    docVerify: {
      title: 'Құжатты тексеру',
      loading: 'Құжат жүктелуде...',
      httpError: 'Сұрау қатесі',
      noData: 'Деректер жоқ',
      badRequest: 'Сұрау қатесі',
      validationError: 'Тексеру қатесі',
      documentNumber: 'Нөмірі',
      documentDate: 'Күні',
      signType: 'Қолтаңба түрі',
      author: 'Автор',
      sender: 'Жіберуші',
      signers: 'Қол қоюшылар',
      decision: 'Шешім',
      signedAt: 'Қол қойылған уақыты',
    },
  },
  ru: {
    docVerify: {
      title: 'Проверка документа',
      loading: 'Загрузка документа...',
      httpError: 'Ошибка запроса',
      noData: 'Нет данных',
      badRequest: 'Ошибка запроса',
      validationError: 'Ошибка валидации',
      documentNumber: 'Номер',
      documentDate: 'Дата',
      signType: 'Тип подписи',
      author: 'Автор',
      sender: 'Отправитель',
      signers: 'Подписанты',
      decision: 'Решение',
      signedAt: 'Подписано',
    },
  },
};

export default docVerifyResources;
